import { createUrl }   from "_common/utils/seo";
import { ShopBaseURL } from "_config/index";

export const getShopProductLink = ( { productId, addUTMParams = false } ) => {
	const productURL = `${ ShopBaseURL }/product/${ productId }`;
	const _url       = new URL ( productURL );

	if ( addUTMParams )
		return createUrl ( _url, { source: "home_page", medium: "web", campaign: productId } );

	return createUrl ( _url );
};

export const getShopLink = overrideParams => {
	const _url = new URL ( ShopBaseURL );

	const _params = overrideParams || { source: "side_nav", medium: "web", campaign: "organic" };

	Object.entries ( _params ).forEach ( ( [ key, value ] ) => {
		_url.searchParams.append ( "utm_" + key, value );
	} );

	return _url.href;
};

export const getProductPrice = data => {
	const defaultVar = data?.variations?.[0];

	const seller = defaultVar?.sellers?.[0];

	const costPrice =  seller.costPrice;
	const sellPrice =  seller.sellPrice;
	const discount  = ( ( costPrice - sellPrice ) / costPrice ) * 100;

	return {
		costPrice,
		sellPrice,
		discount
	};
};
